// extracted by mini-css-extract-plugin
export var centerText = "_55-8";
export var container = "_55-0";
export var doughnutContainer = "_55-7";
export var legend = "_55-a";
export var legendItemColorDisplay = "_55-b";
export var legendItemLabel = "_55-d";
export var legendItemValue = "_55-c";
export var lg = "_55-5";
export var maxWidth = "_55-9";
export var md = "_55-4";
export var responsive = "_55-6";
export var sm = "_55-3";
export var xs = "_55-2";
export var xxs = "_55-1";